import { useState } from 'react'
import { Button } from '@mui/material'
import ControlPointIcon from '@mui/icons-material/ControlPoint'

import { useStyles } from './style'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { ModalWrapper } from 'src/components'
import { Form, Formik } from 'formik'
import { addWhiteLabelPartnerSchema } from 'src/common/validations/white-label-partner-schema.validation'
import { useCreateWhiteLAbelPartner } from 'src/hooks/white-label-partners/useCreateWhiteLabelPartner.hook'
import { ICreateWhiteLabelPartnerDto } from 'src/types/white-label-partners.type'
import { WhiteLabelPartnersForm } from '..'
import { EConfirmModalTitles } from 'src/constants'
import { useItemsRemoveConfirm } from 'src/hooks'

interface IProps {
  open: boolean
  handleClose: () => void
}

export const CreateWhiteLabelPartnerForm = ({ open, handleClose }: IProps) => {
  const { mutateAsync: create } = useCreateWhiteLAbelPartner()
  const classes = useStyles()

  const { setRemoveConfirm } = useItemsRemoveConfirm()

  const handleCreateItem = async (values: ICreateWhiteLabelPartnerDto) => {
    if (!values) return

    handleClose()

    setRemoveConfirm({
      handleConfirm: async () => {
        await create(values)
      },
      customModal: {
        title: EConfirmModalTitles.CREATE,
      },
      itemsTitles: [],
      itemsDetails: [{ text: values.name, title: 'Name' }],
      itemsRelations: [],
      itemsType: '',
    })
  }

  return (
    <ModalWrapper className={classes.modalWrapper} open={open} onClose={handleClose}>
      <Formik
        initialValues={{
          name: '',
          logo: '',
          qr_code_logo: '',
          primary_color: '',
          secondary_color: '',
          alternative_color: '',
          journey_link: '',
          footer: '',
          footer_url: '',
          footer_color: '',
          billing_hidden: false,
        }}
        validationSchema={addWhiteLabelPartnerSchema}
        onSubmit={handleCreateItem}
      >
        <Form>
          <WhiteLabelPartnersForm />
        </Form>
      </Formik>
    </ModalWrapper>
  )
}

export const AddWhiteLabelPartnersModal = () => {
  const [open, setOpen] = useState(false)
  const classes = useStyles()

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <>
      <Button
        className={classes.additionButton}
        color={'primary'}
        size={'large'}
        variant="contained"
        startIcon={<ControlPointIcon />}
        onClick={handleOpen}
      >
        <HelperWrapper t="white-label-partners-create-button" />
      </Button>
      <CreateWhiteLabelPartnerForm handleClose={handleClose} open={open} />
    </>
  )
}
